export const RECAPTCHA_KEY =
  `${process.env.NEXT_PUBLIC_ENV_NAME}` !== 'prod'
    ? '6LfX050lAAAAAFcmcOy1KdiEi2k5bBrmqWptug1V'
    : '6LekoJ0lAAAAAHv_IXXvHAPqt43_lzzyXf61h0fV';

export const recaptchaActions = {
  SET_INFO: 'SET_INFO',
  PROCESS_ORDER: 'PROCESS_ORDER',
  SEND_SMS: 'SEND_SMS',
  VALIDATE_SMS: 'VALIDATE_SMS',
  RETARGETING: 'retargeting_collect',
};

export const WEB_SERVICES = {
  SET_INFO: 'setInfo',
  INIT_PURCHASE: 'initPurchase',
  CHECKOUT: 'checkout',
  SEND_SMS_OTP: 'sendSmsOtp',
  VALIDATE_SMS_OTP: 'validateSmsOtp',
  PROCESS_ORDER: 'processOrder',
  RETARGETING: 'retargeting',
};

export const HANDLING_CODES = {
  NOTHING_TO_DO: 1,
  FATAL: -1,
};

export const ERROR_PAGES = {
  DEFAULT: 'default',
  CHECKOUT: 'checkout',
};

export const webServiceErrorHandler = {
  [WEB_SERVICES.SET_INFO]: {
    service: WEB_SERVICES.SET_INFO,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: ERROR_PAGES.DEFAULT,
  },
  [WEB_SERVICES.INIT_PURCHASE]: {
    service: WEB_SERVICES.INIT_PURCHASE,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: ERROR_PAGES.DEFAULT,
  },
  [WEB_SERVICES.CHECKOUT]: {
    service: WEB_SERVICES.CHECKOUT,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: ERROR_PAGES.CHECKOUT,
  },
  [WEB_SERVICES.PROCESS_ORDER]: {
    service: WEB_SERVICES.CHECKOUT,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: ERROR_PAGES.CHECKOUT,
  },
  [WEB_SERVICES.SEND_SMS_OTP]: {
    service: WEB_SERVICES.SEND_SMS_OTP,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: ERROR_PAGES.CHECKOUT,
  },
  [WEB_SERVICES.VALIDATE_SMS_OTP]: {
    service: WEB_SERVICES.VALIDATE_SMS_OTP,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      457: HANDLING_CODES.NOTHING_TO_DO,
      456: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: ERROR_PAGES.CHECKOUT,
  },
  [WEB_SERVICES.RETARGETING]: {
    service: WEB_SERVICES.RETARGETING,
    handlingCode: {
      default: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: ERROR_PAGES.DEFAULT,
  },
};